module.exports = __webpack_public_path__ + "static/img/i2.d405a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i2.png
// module id = ZkZo
// module chunks = 0